import React, { useState, useEffect, useLayoutEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { ButtonToolbar } from 'reactstrap';
import {
  getItineraryForCounter,
  clearItinerary,
  clearDrivers,
  getListDriversForItinerary,
  getCargoItemByItinerary,
  clearItemToItinerary,
  getPassengerFlowForItinerary,
  clearPassengerFlowForItinerary,
  getItineraryGeofenceAlerts,
  putBoardPassenger,
} from '../../../../../actions/index';
import Loader from '../../../../common/Loader';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import {
  CIRCUIT_PATH,
  ITINERARY_FOR_COUNTER_PATH,
  ROUTE_PATH,
} from '../../../../../config/paths';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../../common/resource/proptypes/CommonPropTypes';
import IsActive from '../../../../common/cells/IsActive';
import { Table } from '../../../../common/Table';
import { DATE_TIME_FORMAT } from '../../../../../config/locale';
import ItineraryForCounterToolbar from './ItineraryForCounterToolbar';
import Modal from '../../../../common/modal/Modal';
import TimetableTemplate from '../TimetableTemplate';
import {
  ITINERARY_SCHEDULE_WITHOUT_SEGMENT_LIST_MESSAGE,
  ITINERARY_WITHOUT_CABIN_CREW_INFO_MESSAGE,
  ITINERARY_WITHOUT_CARGO_MESSAGE,
  ITINERARY_WITHOUT_DRIVER_INFO_MESSAGE,
  ITINERARY_WITHOUT_PASSENGER_FLOW_MESSAGE,
} from '../../../../../config/messages';
import NoDataResource from '../../../../common/resource/NoDataResource';
import Content from '../../../../layout/Content';
import Alert from '../../../../common/informative/Alert';
import {
  DEFAULT_PAGE_SIZE,
  ITINERARY_TYPE,
} from '../../../../../config/constants';
import { tzNormalizeDate } from '../../../../../utils/date';
import {
  DEFAULT_QUERY,
  DEFAULT_QUERY_GET_ALL,
} from '../../../../../config/queries';
import { CARGO_ITINERARY_COLUMNS } from '../../../../../config/columns';
import CollapsibleHeader from '../../../../layout/CollapsibleHeader';
import ItineraryGeofenceAlerts from '../itinerary/ItineraryGeofenceAlerts';
import ItineraryHistoryAlerts from '../itinerary/ItineraryHistoryAlerts';
import ItineraryForCounterPassengerFlowForm from './ItineraryForCounterPassengerFlowForm';
import LinkToModuleResource from '../../../../common/resource/LinkToModuleResource';
import ItineraryMassivePostponeButton from '../itinerary/ItineraryMassivePostponeButton';
import { getTicketReassignments } from '../../../../../actions/reservation/TicketReassignment';
import TicketReassignmentTable from './ticket-reassignment/TicketReassignmentTable ';

import ConfirmationModal from '../../../../common/modal/ConfirmationModal';
import ItineraryTicketTable from './ItineraryTicketTable';
import ItineraryFoodButton from '../itinerary-food/ItineraryFoodButton';
import ItineraryFoodSection from './ItineraryFoodSection';
import DeleteItineraryFoodButton from '../itinerary-food/DeleteItineraryFoodButton';
import DeleteItineraryAdditionalFoodButton from '../itinerary-food/DeleteItineraryAdditionalFoodButton';
import Checkbox from '../../../../common/forms/Checkbox';
import AddItineraryFoodButton from '../itinerary-food/AddItineraryFoodButton';

const Itinerary = ({
  breadcrumbs,
  itinerary,
  loading,
  drivers,
  loadingCargoItems,
  cargoItems,
  passengerFlow,
  dispatchGetCargoItemByItinerary,
  match,
  dispatchGetItineraryForCounter,
  dispatchClearItinerary,
  dispatchGetListDriversForItinerary,
  dispatchClearDrivers,
  dispatchClearItemToItinerary,
  dispatchGetPassengerFlowForItinerary,
  dispatchClearPassengerFlowForItinerary,
  dispatchGetItineraryGeofenceAlerts,
  dispatchPutBoardPassenger,
  geofenceAlerts,
  dispatchGetTicketReassignments,
  ticketReassignments,
  loadingTicketReassignments,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalBody, setModalBody] = useState(null);

  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [formValuesPassengerFlow, setFormValuesPassengerFlow] = useState(null);

  const { id: itineraryId } = match.params;

  useLayoutEffect(() => {
    dispatchGetPassengerFlowForItinerary({ itineraryId });
  }, []);

  useEffect(() => {
    dispatchGetItineraryForCounter(itineraryId);
    dispatchGetListDriversForItinerary({ itineraryId });
    dispatchGetCargoItemByItinerary({ itineraryId, ...DEFAULT_QUERY });
    dispatchGetItineraryGeofenceAlerts(itineraryId);
    dispatchGetTicketReassignments({
      ...DEFAULT_QUERY_GET_ALL,
      query: [`previousItineraryId:${itineraryId}`],
    });

    return () => {
      dispatchClearItinerary();
      dispatchClearDrivers();
      dispatchClearItemToItinerary();
      dispatchClearPassengerFlowForItinerary();
    };
  }, [
    itineraryId,
    dispatchGetItineraryForCounter,
    dispatchGetListDriversForItinerary,
    dispatchGetCargoItemByItinerary,
    dispatchGetItineraryGeofenceAlerts,
    dispatchClearItinerary,
    dispatchClearDrivers,
    dispatchClearItemToItinerary,
    dispatchClearPassengerFlowForItinerary,
  ]);

  const onSubmitPassengerFlow = async ({ isBoarding, ...formValues }) => {
    setShowConfirmationModal(true);
    setFormValuesPassengerFlow({ ...formValues, itineraryId, isBoarding });
  };

  const closeConfirmationModal = () => {
    setShowConfirmationModal(false);
    setFormValuesPassengerFlow(null);
  };

  const closePassengerFlowModal = () => {
    setShowModal(false);
    setModalTitle('');
    setModalBody(null);
  };

  const onConfirmPassengerFlow = () => {
    dispatchPutBoardPassenger(formValuesPassengerFlow);
    closeConfirmationModal();

    const { isBoarding } = formValuesPassengerFlow;

    if (isBoarding) closePassengerFlowModal();
  };

  const renderPassengerFlowModal = (type, currentPassengerFlow, index) => {
    const isBoarding = type === 'boarding';
    const title = `${isBoarding ? 'Embarque' : 'Desembarque'}: ${
      currentPassengerFlow.locationName
    } (${currentPassengerFlow[`${type}Passengers`]})`;

    const body = (
      <div style={{ maxHeight: '80vh', overflowY: 'auto' }}>
        <ItineraryForCounterPassengerFlowForm
          onSubmit={(formValues) =>
            onSubmitPassengerFlow({ ...formValues, isBoarding })
          }
          type={type}
          index={index}
          itineraryId={itineraryId}
        />
      </div>
    );

    setShowModal(true);
    setModalTitle(title);
    setModalBody(body);
  };

  const renderPassengersFlow = (type, renderPassengerFlow, index) => {
    let passengers = 0;

    if (renderPassengerFlow[`${type}Passengers`]) {
      passengers = (
        <div
          role="button"
          onClick={() =>
            renderPassengerFlowModal(type, renderPassengerFlow, index)
          }
          onKeyPress={() =>
            renderPassengerFlowModal(type, renderPassengerFlow, index)
          }
          tabIndex="0"
          className="clickable"
        >
          <strong>
            <u>{renderPassengerFlow[`${type}Passengers`]}</u>
          </strong>
        </div>
      );
    }
    return passengers;
  };

  let content;
  let toolbar;

  if (loading) {
    content = <Loader />;
  } else if (itinerary.isEmpty()) {
    content = <NoDataResource returnPage={ITINERARY_FOR_COUNTER_PATH} />;
  } else {
    const itineraryResource = (
      <>
        <h3>Información Básica</h3>
        <ResourceProperty label="Id:">{itinerary.get('id')}</ResourceProperty>
        <ResourceProperty label="ID de Correlación Civa:">
          {itinerary.get('itineraryCorrelationId') || '-'}
        </ResourceProperty>
        <ResourceProperty label="Ruta:">
          {itinerary.get('routeName')}
          <LinkToModuleResource
            text=""
            href={`${ROUTE_PATH}/${itinerary.get('routeId')}`}
            isExternalPath
          />
        </ResourceProperty>
        <ResourceProperty label="Circuito:">
          {itinerary.get('circuitName')}{' '}
          <LinkToModuleResource
            text=""
            href={`${CIRCUIT_PATH}/${itinerary.get('circuitId')}`}
            isExternalPath
          />
        </ResourceProperty>
        <ResourceProperty label="Tipo de Servicio:">
          {itinerary.get('serviceTypeName')}
        </ResourceProperty>
        <ResourceProperty label="Estado:">
          <IsActive value={itinerary.get('active')} />
        </ResourceProperty>
        <ResourceProperty label="Tipo:">
          {ITINERARY_TYPE[itinerary.get('type').toLowerCase()].label}
        </ResourceProperty>
        {itinerary.get('fundicionEntryAllowance') && (
          <ResourceProperty label="Ingreso a Lima Fundición:">
            <Checkbox
              checked={itinerary.get('fundicionEntryAllowance') || false}
            />
          </ResourceProperty>
        )}
        <ResourceProperty label="Observaciones Adicionales:">
          {itinerary.get('comment')}
        </ResourceProperty>
      </>
    );

    const busResource = (
      <>
        <ResourceProperty label="Número:">
          {itinerary.get('companyBusId') ? itinerary.get('companyBusId') : '-'}
        </ResourceProperty>
        <ResourceProperty label="Matrícula:">
          {itinerary.get('licensePlate') ? itinerary.get('licensePlate') : '-'}
        </ResourceProperty>
        <ResourceProperty label="Estado:">
          {itinerary.get('tripStatus') ? itinerary.get('tripStatus').name : '-'}
        </ResourceProperty>
      </>
    );

    let timetableTemplate = (
      <Alert message={ITINERARY_SCHEDULE_WITHOUT_SEGMENT_LIST_MESSAGE} />
    );

    if (itinerary.get('itineraryScheduleSegmentList').length) {
      timetableTemplate = (
        <TimetableTemplate
          itineraryScheduleSegmentList={itinerary.get(
            'itineraryScheduleSegmentList',
          )}
          estimatedDepartureTime={itinerary.get('estimatedDepartureTime')}
          itineraryRealTimeList={geofenceAlerts}
        />
      );
    }

    const driverData = itinerary.get('driverList');

    let driverResource = (
      <Alert message={ITINERARY_WITHOUT_DRIVER_INFO_MESSAGE} />
    );

    if (driverData && driverData.length > 0) {
      driverResource = (
        <div className="mb-3">
          <Table
            columns={[
              {
                Header: 'Nombre',
                accessor: 'fullName',
                className: 'text-center',
              },
              {
                Header: 'DNI',
                accessor: 'idDocumentNumber',
                className: 'text-center',
              },
            ]}
            data={driverData}
            defaultPageSize={driverData.length}
            showPagination={false}
          />
        </div>
      );
    }

    const cabinCrewData = itinerary.get('cabinCrewList');

    let cabinCrewResource = (
      <Alert
        type="warning"
        message={ITINERARY_WITHOUT_CABIN_CREW_INFO_MESSAGE}
      />
    );

    if (cabinCrewData.length > 0) {
      cabinCrewResource = (
        <div className="mb-3">
          <Table
            columns={[
              {
                Header: 'Nombre',
                accessor: 'fullName',
                className: 'text-center',
              },
              {
                Header: 'DNI',
                accessor: 'idDocumentNumber',
                className: 'text-center',
              },
            ]}
            data={cabinCrewData}
            defaultPageSize={cabinCrewData.length}
            showPagination={false}
          />
        </div>
      );
    }

    let cargoItemResource = (
      <Alert type="warning" message={ITINERARY_WITHOUT_CARGO_MESSAGE} />
    );

    const data = cargoItems.get('content') || [];
    const pages = cargoItems.get('totalPages') || null;
    const defaultPageSize = cargoItems.get('size') || DEFAULT_PAGE_SIZE;
    if (data.length > 0) {
      cargoItemResource = (
        <div className="mb-3">
          <Table
            columns={CARGO_ITINERARY_COLUMNS}
            data={data}
            pages={pages}
            defaultPageSize={defaultPageSize}
            loading={loadingCargoItems}
            fetchData={dispatchGetCargoItemByItinerary}
            params={{ itineraryId }}
          />
        </div>
      );
    }

    const stadisticResource = (
      <>
        <ResourceProperty label="Hora Estimada de Salida:">
          {itinerary.get('estimatedDepartureTime')
            ? tzNormalizeDate({
                date: itinerary.get('estimatedDepartureTime'),
                format: DATE_TIME_FORMAT,
              })
            : '-'}
        </ResourceProperty>
        <ResourceProperty label="Hora Real de Salida:">
          {itinerary.get('actualDepartureTime')
            ? tzNormalizeDate({
                date: itinerary.get('actualDepartureTime'),
                format: DATE_TIME_FORMAT,
              })
            : '-'}
        </ResourceProperty>
        <ResourceProperty label="Hora Estimada de Llegada:">
          {itinerary.get('estimatedArrivalTime')
            ? tzNormalizeDate({
                date: itinerary.get('estimatedArrivalTime'),
                format: DATE_TIME_FORMAT,
              })
            : '-'}
        </ResourceProperty>
        <ResourceProperty label="Hora Real de Llegada:">
          {itinerary.get('actualArrivalTime')
            ? tzNormalizeDate({
                date: itinerary.get('actualArrivalTime'),
                format: DATE_TIME_FORMAT,
              })
            : '-'}
        </ResourceProperty>
      </>
    );

    let passengerFlowTable = (
      <Alert
        type="warning"
        message={ITINERARY_WITHOUT_PASSENGER_FLOW_MESSAGE}
      />
    );

    if (!passengerFlow.isEmpty()) {
      const passengerFlowData = passengerFlow.get(
        'passengerFlowForLocationList',
      );

      passengerFlowTable = (
        <div className="mb-3">
          <Table
            columns={[
              {
                Header: 'Parada Autorizada',
                accessor: 'locationName',
                className: 'text-center',
              },
              {
                Header: 'Embarques',
                accessor: 'boardingPassengers',
                className: 'text-center',
                Cell: (row) =>
                  renderPassengersFlow('boarding', row.original, row.index),
              },
              {
                Header: 'Desembarques',
                accessor: 'leavingPassengers',
                className: 'text-center',
                Cell: (row) =>
                  renderPassengersFlow('leaving', row.original, row.index),
              },
            ]}
            data={passengerFlowData || []}
            defaultPageSize={
              passengerFlowData ? passengerFlowData.length : DEFAULT_PAGE_SIZE
            }
            showPagination={false}
          />
        </div>
      );
    }

    const passengerFlowResource = (
      <>
        <h3>Flujo de Pasajeros</h3>
        {passengerFlowTable}
        <CollapsibleHeader
          headerText="Boletos"
          component={ItineraryTicketTable}
          itineraryId={itineraryId}
        />
      </>
    );

    const itineraryHistoryAlertResource = (
      <>
        <hr />
        <CollapsibleHeader
          headerText="Historial de alertas"
          component={ItineraryHistoryAlerts}
          itineraryId={itineraryId}
        />
      </>
    );

    const itineraryGeofenceAlertResource = (
      <>
        <hr />
        <CollapsibleHeader
          headerText="Alertas de Geocercas"
          component={ItineraryGeofenceAlerts}
          itineraryId={itineraryId}
        />
      </>
    );

    let ticketReassignmentResource = null;

    if (ticketReassignments.length > 0) {
      ticketReassignmentResource = (
        <TicketReassignmentTable
          ticketReassignments={ticketReassignments}
          loading={loadingTicketReassignments}
          itineraryId={itineraryId}
        />
      );
    }

    content = (
      <>
        {itineraryResource}
        <h3>Horarios</h3>
        <div className="mb-3">{timetableTemplate}</div>
        <h3>Bus</h3>
        {busResource}
        <h3>Conductores</h3>
        {driverResource}
        {passengerFlowResource}
        <h3>Servicio a Bordo</h3>
        {cabinCrewResource}
        <ItineraryFoodSection
          itineraryId={itineraryId}
          itineraryFoods={itinerary.get('itineraFoodList') || []}
        />
        <h3>Reasignaciones de Boletos</h3>
        {ticketReassignmentResource}
        <h3>Carga asignada</h3>
        {cargoItemResource}
        <h3>Estadísticas</h3>
        {stadisticResource}
        {itineraryGeofenceAlertResource}
        {itineraryHistoryAlertResource}
        <Modal
          show={showModal}
          title={modalTitle}
          body={modalBody}
          fullSize
          onClickClose={() => setShowModal(false)}
        />
        <ConfirmationModal
          show={showConfirmationModal}
          onClickConfirm={onConfirmPassengerFlow}
          onClickCancel={closeConfirmationModal}
        />
      </>
    );

    if (itinerary.get('companyBusId') !== null) {
      toolbar = (
        <ItineraryForCounterToolbar
          itineraryId={itinerary.get('id')}
          drivers={drivers}
          itineraryFoods={itinerary.get('itineraFoodList') || []}
        />
      );
    } else {
      const hasItineraryFoodList =
        itinerary.get('itineraFoodList') &&
        itinerary.get('itineraFoodList').length > 0;

      toolbar = (
        <ButtonToolbar className="pull-right">
          <div>
            <ItineraryFoodButton itineraryId={itinerary.get('id')} />{' '}
            <AddItineraryFoodButton itineraryId={itinerary.get('id')} />
            {hasItineraryFoodList && (
              <>
                <ItineraryMassivePostponeButton
                  itineraryId={itinerary.get('id')}
                />{' '}
                <DeleteItineraryFoodButton itineraryId={itineraryId} />{' '}
                <DeleteItineraryAdditionalFoodButton
                  itineraryId={itineraryId}
                />
              </>
            )}
          </div>
        </ButtonToolbar>
      );
    }
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Itinerario"
      toolbar={toolbar}
      content={content}
    />
  );
};

const mapStateToProps = ({ ItineraryUnit, CargoUnit, ReservationUnit }) => ({
  breadcrumbs: [
    ...ItineraryUnit.UnitHome.get('breadcrumbs'),
    { text: 'Búsqueda de Itinerarios', href: ITINERARY_FOR_COUNTER_PATH },
    { text: 'Ver', href: '' },
  ],
  itinerary: ItineraryUnit.Itinerary.getIn(['current', 'content']),
  loading: !ItineraryUnit.Itinerary.getIn(['current', 'activity']).isEmpty(),
  drivers: ItineraryUnit.Itinerary.getIn(['current', 'drivers']),
  cargoItems: CargoUnit.ItemToItinerary.getIn(['current', 'items']),
  loadingCargoItems: !CargoUnit.ItemToItinerary.getIn([
    'current',
    'activity',
  ]).isEmpty(),
  passengerFlow: ItineraryUnit.Itinerary.getIn(['current', 'passengerFlow']),
  geofenceAlerts: ItineraryUnit.Itinerary.getIn([
    'current',
    'geofenceAlerts',
  ]).toJS(),
  ticketReassignments: ReservationUnit.TicketReassignment.getIn([
    'all',
    'content',
    'content',
  ]),
  loadingTicketReassignments: ReservationUnit.TicketReassignment.getIn([
    'all',
    'loading',
  ]),
  userCurrentLocationId: ItineraryUnit.Itinerary.getIn([
    'current',
    'passengerFlow',
    'userCurrentLocationId',
  ]),
});

const mapDispatchToProps = {
  dispatchGetItineraryForCounter: getItineraryForCounter,
  dispatchClearItinerary: clearItinerary,
  dispatchGetListDriversForItinerary: getListDriversForItinerary,
  dispatchClearDrivers: clearDrivers,
  dispatchGetCargoItemByItinerary: getCargoItemByItinerary,
  dispatchClearItemToItinerary: clearItemToItinerary,
  dispatchGetPassengerFlowForItinerary: getPassengerFlowForItinerary,
  dispatchClearPassengerFlowForItinerary: clearPassengerFlowForItinerary,
  dispatchGetItineraryGeofenceAlerts: getItineraryGeofenceAlerts,
  dispatchPutBoardPassenger: putBoardPassenger,
  dispatchGetTicketReassignments: getTicketReassignments,
};

Itinerary.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  match: matchPropTypes.isRequired,
  itinerary: PropTypes.instanceOf(Immutable.Map).isRequired,
  drivers: PropTypes.instanceOf(Immutable.Set).isRequired,
  loading: PropTypes.bool.isRequired,
  dispatchGetItineraryForCounter: PropTypes.func.isRequired,
  dispatchClearItinerary: PropTypes.func.isRequired,
  dispatchGetListDriversForItinerary: PropTypes.func.isRequired,
  dispatchClearDrivers: PropTypes.func.isRequired,
  dispatchGetCargoItemByItinerary: PropTypes.func.isRequired,
  dispatchClearItemToItinerary: PropTypes.func.isRequired,
  cargoItems: PropTypes.instanceOf(Immutable.Set).isRequired,
  loadingCargoItems: PropTypes.bool.isRequired,
  dispatchGetPassengerFlowForItinerary: PropTypes.func.isRequired,
  dispatchClearPassengerFlowForItinerary: PropTypes.func.isRequired,
  dispatchPutBoardPassenger: PropTypes.func.isRequired,
  passengerFlow: PropTypes.instanceOf(Immutable.Map).isRequired,
  geofenceAlerts: PropTypes.arrayOf(Immutable.List).isRequired,
  ticketReassignments: PropTypes.arrayOf(Immutable.Map).isRequired,
  dispatchGetItineraryGeofenceAlerts: PropTypes.func.isRequired,
  dispatchGetTicketReassignments: PropTypes.func.isRequired,
  loadingTicketReassignments: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Itinerary);
